import React from "react";

export const ExportOptionRow = ({ label, error, children }: { label: string; error?: boolean; children: React.ReactNode }) => (
  <div className="tw-flex tw-flex-col tw-gap-1.5 tw-border-b tw-border-slate-100 tw-py-3 last:tw-border-0 dark:tw-border-slate-700 md:tw-flex-row md:tw-items-center md:tw-justify-between md:tw-gap-6">
    <span className="tw-shrink-0 tw-text-sm tw-font-medium tw-text-slate-600 dark:tw-text-slate-300">{label}</span>
    <div className="tw-w-full md:tw-max-w-md">{children}{error && <p className="tw-mt-1 tw-text-xs tw-text-red-600">This field is required.</p>}</div>
  </div>
);
